import template from './createProjectModal.html';
import controller from './createProjectModal.controller';

let CreateProjectModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
CreateProjectModalComponent.template = template;
CreateProjectModalComponent.controller = controller;

export default CreateProjectModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/createProjectModal/createProjectModal.component.js